import { useContext } from 'react';
import { useAuth } from './context/auth-context';

import Home from './components/Home';
import LoadingSpinner from './components/LoadingSpinner';
import LogoutModal from './components/LogoutModal';
import ErrorBanner from './components/error-banner';
import Spinner from './components/spinner';
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import { ExclamationTriangleIcon } from '@heroicons/react/24/solid';

function App() {
  const { state, send } = useAuth();
  const { t } = useTranslation();

  // Show the loading spinner while the user is not authenticated
  if (!state.matches('authenticated') && !state.matches('error')) {
    return <LoadingSpinner />;
  }
  // If the user is authenticated display the home component
  else if (state.matches('authenticated')) {
    return (
      <>
        <Home />
        <LogoutModal />
        {state.matches('authenticated.retrying refresh') && (
          <ErrorBanner>
            <Trans
              i18nKey="errors.token_refresh_failed"
              values={{
                count: state.context.retryRefreshAttempts,
                maxRetries: state.context.maxRefreshRetries,
              }}
              components={{
                spinner: (
                  <Spinner color="red" sizeClass="h-4 w-4 sm:h-5 sm:w-5 " />
                ),
                exclamation: (
                  <ExclamationTriangleIcon
                    className="h-8 w-8  text-red-500 dark:text-red-400  sm:h-5 sm:w-5"
                    aria-hidden="true"
                  />
                ),
              }}
            />
          </ErrorBanner>
        )}
      </>
    );
  } else if (state.matches('error')) {
    return (
      <>
        <div className="flex h-screen">
          <div className="m-auto">
            <div className="w-96 text-center">
              <p className="text-3xl font-semibold text-red-600">
                {t('errors.authentication_error')}
              </p>
              <p className="text-wrap mt-3 text-base leading-7 text-gray-600">
                {t('errors.authentication_error_explanation')}
              </p>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default App;
